/**
 * Calculate the arbitrary date range relative to given time epoch and padding.
 */
export const calculateArbitraryDateRange = (
  targetTime: number,
  padding: number
) => {
  const arbitraryFromTime = new Date(targetTime - (padding / 2) * 1000);
  const arbitraryToTime = new Date(targetTime + (padding / 2) * 1000);

  return [arbitraryFromTime.getTime(), arbitraryToTime.getTime()] as const;
};
